(function (w, d, s, o, f, js, fjs) {
  w["Avease-Widget"] = o;
  w[o] =
    w[o] ||
    function () {
      (w[o].q = w[o].q || []).push(arguments);
    };
  (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
  js.id = o;
  js.src = f;
  js.async = 1;
  fjs.parentNode.insertBefore(js, fjs);
})(
  window,
  document,
  "script",
  "av",
   "https://widget.avease.ai/assets/snippet.js"
);
av("config", {
  id: "c554bbbb-0b67-452b-aa12-caedc41228c9"
});
av("init");